import { MasterCropData } from '../types';

const REMOTE_DC_TEMP_CROP_PREFIX = 'remote-dc:';

function parseRemoteDcTempCropId(cropId: string): {
  namespace: string;
  shapeList: string;
  index: number;
} | null {
  if (!cropId.startsWith(REMOTE_DC_TEMP_CROP_PREFIX)) return null;

  const rawDetectionId = cropId.slice(REMOTE_DC_TEMP_CROP_PREFIX.length);
  const parts = rawDetectionId.split(':');
  if (parts.length < 3) return null;

  const rawIndex = parts[parts.length - 1];
  const index = Number(rawIndex);
  if (!Number.isInteger(index)) return null;

  const shapeList = parts[parts.length - 2];
  const namespace = parts.slice(0, -2).join(':');
  return { namespace, shapeList, index };
}

export function compareMasterLabelCropIds(leftId: string, rightId: string): number {
  const leftRemote = parseRemoteDcTempCropId(leftId);
  const rightRemote = parseRemoteDcTempCropId(rightId);

  if (leftRemote && rightRemote) {
    const namespaceCompare = leftRemote.namespace.localeCompare(rightRemote.namespace);
    if (namespaceCompare !== 0) return namespaceCompare;
    const shapeCompare = leftRemote.shapeList.localeCompare(rightRemote.shapeList);
    if (shapeCompare !== 0) return shapeCompare;
    if (leftRemote.index !== rightRemote.index) return leftRemote.index - rightRemote.index;
  }

  return leftId.localeCompare(rightId);
}

export function compareMasterLabelCropsBySourceThenId(
  left: MasterCropData,
  right: MasterCropData
): number {
  const leftScan = left.source === 'scan' ? 0 : 1;
  const rightScan = right.source === 'scan' ? 0 : 1;
  if (leftScan !== rightScan) return leftScan - rightScan;
  if (
    left.remoteDataCollectionDraftOrder !== undefined &&
    right.remoteDataCollectionDraftOrder !== undefined &&
    left.remoteDataCollectionDraftOrder !== right.remoteDataCollectionDraftOrder
  ) {
    return left.remoteDataCollectionDraftOrder - right.remoteDataCollectionDraftOrder;
  }
  return compareMasterLabelCropIds(left.id, right.id);
}
